// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3EYiN","errorLogs":"EditorFooter_errorLogs__3vQYl"};